<template>
    <div :class="props.outerClass" v-if="props.spaceInfo?.entitiesImagePanoramaEavValue" >
        <div :class="props.innerClass" @click.prevent="HandlePanoramaPage">
        <svg width="21" height="10" viewBox="0 0 21 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_20446_46)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.49113 9.47862C3.66318 9.06152 0.0135498 7.15329 0.0135498 4.8488C0.0135498 3.4098 1.44212 2.11679 3.70489 1.2513C2.00521 2.03337 0.952027 3.09698 0.952027 4.27529C0.952027 6.35037 4.20542 8.07091 8.53284 8.47758L8.5537 8.01877L9.6903 8.55057L10.8269 9.08238L9.65901 9.54119L8.49113 10L8.51198 9.47862H8.49113Z"
                fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                d="M17.1773 1.2513C19.4296 2.11679 20.8686 3.39938 20.8686 4.8488C20.8686 7.27842 16.781 9.2805 11.5464 9.53076V8.52972C16.2701 8.27946 19.9301 6.4755 19.9301 4.27529C19.9301 3.09698 18.8769 2.03337 17.1773 1.26173"
                fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.9448 1.52242C13.8301 1.52242 13.7258 1.56413 13.6424 1.63712C13.5485 1.71012 13.4859 1.84567 13.4338 2.03337C13.3712 2.28363 13.34 2.70073 13.34 3.2951C13.34 3.88947 13.3712 4.29614 13.4234 4.51512C13.4859 4.7341 13.5589 4.88009 13.6424 4.95308C13.7258 5.02607 13.8301 5.06778 13.9448 5.06778C14.0595 5.06778 14.1637 5.02607 14.2576 4.95308C14.3514 4.88009 14.414 4.74453 14.4661 4.55683C14.5287 4.30657 14.56 3.88947 14.56 3.2951C14.56 2.70073 14.5287 2.29406 14.4766 2.07508C14.414 1.8561 14.341 1.69969 14.2576 1.6267C14.1637 1.5537 14.0699 1.51199 13.9552 1.51199M13.9552 0.709074C14.4453 0.709074 14.8207 0.886342 15.1022 1.23045C15.4255 1.64755 15.5923 2.32534 15.5923 3.28467C15.5923 4.24401 15.4255 4.9218 15.1022 5.3389C14.8311 5.683 14.4453 5.86027 13.9656 5.86027C13.4859 5.86027 13.0793 5.67258 12.7769 5.29719C12.4745 4.9218 12.3285 4.24401 12.3285 3.27425C12.3285 2.30449 12.4953 1.63712 12.8186 1.22002C13.0897 0.875914 13.4755 0.698647 13.9552 0.698647V0.709074ZM9.4922 4.07717C9.4922 4.38999 9.5652 4.62982 9.71118 4.80709C9.85717 4.97393 10.024 5.06778 10.2013 5.06778C10.3785 5.06778 10.5245 4.99479 10.6497 4.85923C10.7644 4.72367 10.8269 4.48384 10.8269 4.17101C10.8269 3.85819 10.7644 3.5975 10.6392 3.45151C10.5141 3.2951 10.3473 3.22211 10.1596 3.22211C9.97187 3.22211 9.81546 3.2951 9.69033 3.44109C9.5652 3.58707 9.50263 3.80605 9.50263 4.08759L9.4922 4.07717ZM11.682 1.97081L10.7435 2.07508C10.7227 1.88738 10.6601 1.7414 10.5662 1.64755C10.4724 1.5537 10.3473 1.51199 10.1908 1.51199C9.9823 1.51199 9.81546 1.60584 9.66947 1.78311C9.53391 1.97081 9.44007 2.3462 9.40878 2.93014C9.64862 2.64859 9.95101 2.50261 10.3056 2.50261C10.7122 2.50261 11.0563 2.65902 11.3379 2.96142C11.6298 3.27425 11.7654 3.67049 11.7654 4.15016C11.7654 4.66111 11.6194 5.07821 11.317 5.39103C11.0146 5.70386 10.6288 5.86027 10.1491 5.86027C9.63819 5.86027 9.22109 5.66215 8.89783 5.2659C8.57458 4.86966 8.40774 4.22315 8.40774 3.31596C8.40774 2.40876 8.57458 1.72054 8.91869 1.31387C9.2628 0.907197 9.70075 0.698647 10.243 0.698647C10.6288 0.698647 10.9416 0.802922 11.1919 1.0219C11.4422 1.24088 11.5986 1.5537 11.6716 1.96038L11.682 1.97081ZM4.47656 4.44213L5.41504 4.32743C5.44632 4.56726 5.51932 4.74453 5.65487 4.88009C5.78 5.00522 5.94684 5.06778 6.12411 5.06778C6.32223 5.06778 6.48908 4.99479 6.62463 4.83838C6.76019 4.69239 6.82276 4.48384 6.82276 4.22315C6.82276 3.98332 6.76019 3.78519 6.62463 3.64964C6.4995 3.50365 6.33266 3.44109 6.14497 3.44109C6.01984 3.44109 5.87385 3.46194 5.70701 3.51408L5.81129 2.73201C6.07197 2.73201 6.2701 2.67988 6.40566 2.56517C6.54121 2.45047 6.61421 2.28363 6.61421 2.08551C6.61421 1.91867 6.56207 1.78311 6.46822 1.67883C6.36395 1.57456 6.23881 1.53285 6.06155 1.53285C5.88428 1.53285 5.75915 1.59541 5.64445 1.71012C5.52974 1.82482 5.45675 1.99166 5.43589 2.21064L4.54955 2.06465C4.61212 1.76225 4.70597 1.51199 4.8311 1.3243C4.95623 1.1366 5.1335 1.00104 5.35247 0.89677C5.57145 0.792494 5.82171 0.740357 6.10326 0.740357C6.5725 0.740357 6.95831 0.886342 7.23986 1.19917C7.47969 1.44943 7.59439 1.73097 7.59439 2.0438C7.59439 2.48175 7.35456 2.84672 6.86447 3.10741C7.15644 3.16997 7.38584 3.30553 7.55268 3.52451C7.72995 3.74348 7.81337 4.00417 7.81337 4.30657C7.81337 4.74453 7.64653 5.13035 7.33371 5.43274C7.01045 5.74557 6.61421 5.90198 6.13454 5.90198C5.67573 5.90198 5.30034 5.76643 5.00837 5.50574C4.70597 5.24505 4.53913 4.90094 4.48699 4.47341L4.47656 4.44213Z"
                fill="white" />
                <path
                d="M15.9676 1.23045C15.634 1.23045 15.3524 0.959333 15.3524 0.615224C15.3524 0.271116 15.6235 0 15.9676 0C16.3117 0 16.5829 0.271116 16.5829 0.615224C16.5829 0.959333 16.3117 1.23045 15.9676 1.23045ZM15.9676 0.333681C15.8112 0.333681 15.6757 0.458811 15.6757 0.625652C15.6757 0.792492 15.8008 0.917623 15.9676 0.917623C16.1345 0.917623 16.2596 0.792492 16.2596 0.625652C16.2596 0.458811 16.1345 0.333681 15.9676 0.333681Z"
                fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_20446_46">
                <rect width="20.8551" height="10" fill="white" transform="translate(0.0135498)" />
                </clipPath>
            </defs>
        </svg>
        <span class="text-white">360°ツアー</span>
        </div>
    </div>
    <div v-else></div>
  </template>
  
  <script setup>
  import { defineProps } from "vue";
  import { ROUTER_PATH} from "@/client/const";
  
  const props = defineProps({
    spaceInfo: {
      type: Object,
      default: () => {},
    },
    outerClass: {
        type: String,
        required: true,
    },
    innerClass: {
        type: String,
        required: true,
    },
  });

  const HandlePanoramaPage = () => {
      let url;
      let PanoramaEnvValue = props.spaceInfo?.entitiesImagePanoramaEavValue;
      if (PanoramaEnvValue?.length > 0) {
          const firstImageTitle = PanoramaEnvValue;
  
          var urlPattern = /(https?:\/\/|www\.)[^\s]+/g;
  
          if (urlPattern.test(firstImageTitle)) {
              url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}&show=true`;
          } else if(PanoramaEnvValue[0].width != 0 && PanoramaEnvValue[0].height != 0) {
              url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}`;
          }
      } else {
          url = `${ROUTER_PATH.PANORAMA}?id=${props.spaceInfo?.id}`;
      }
  
      window.open(url, '_blank')
  };
  </script>
  <style scoped lang="scss">
    .main-panorama-degree-tour{
        @media only screen and (max-width: 425px) {
            display: none;
        }
    }

    .main-panorama-degree-tour , .main-panorama-degree-tour-recommend{
        height: 18px;
        .panorama-degree-tour , .panorama-degree-tour-recommend{
            display: flex;
            padding: 0 3px;
            align-items: center;
            gap: 3px;
            width: max-content;
            border-bottom: 7px;
            background: linear-gradient(0deg, #165089 0%, #022856 100%);
            border-radius: 2px;
            opacity: 1;
            cursor: pointer;
            
            span {
                @media only screen and (max-width: 768px) {
                    font-size: 14px;
                }
            }
        }
    }
    .main-panorama-degree-tour-sp{
        display: none;
        @media only screen and (max-width: 425px) {
        display: block;
        }
        .panorama-degree-tour-sp{
            display: flex !important;
            padding: 0 3px !important;
            align-items: center;
            gap: 3px;
            width: max-content;
            border-bottom: 7px;
            background: linear-gradient(0deg, #165089 0%, #022856 100%);
            border-radius: 2px;
            cursor: pointer;
            font-size: 14px !important;
            font-weight: normal !important;
            line-height: 21px !important;
            span {
                @media only screen and (max-width: 350px) {
                    font-size: 10px;
                }
            }
        }
    }

  </style>
  